import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableRow from '@mui/material/TableRow';
import TableCell from 'components/TableCell';

import { RoomRatesTableRateEditorPriceBreakdown_roomRate$key } from '__generated__/RoomRatesTableRateEditorPriceBreakdown_roomRate.graphql';

type Props = {
  roomRate: RoomRatesTableRateEditorPriceBreakdown_roomRate$key | null;
};

const RoomRatesTableRateEditorPriceBreakdown: FC<Props> = props => {
  const roomRate = useFragment(
    graphql`
      fragment RoomRatesTableRateEditorPriceBreakdown_roomRate on RoomRate {
        tripPriceAdult
        tripPriceChild
        baseCostAdult
        baseCostChild
        isPercentMarkup
        markupPercentAdult
        markupPercentChild
        markupAmountAdult
        markupAmountChild
      }
    `,
    props.roomRate
  );

  if (!roomRate) return null;

  return (
    <>
      <TableRow>
        <TableCell sx={{ fontWeight: 'bold' }}>Viso savikaina</TableCell>
        <TableCell center>€{roomRate.baseCostAdult}</TableCell>
        <TableCell center>€{roomRate.baseCostChild}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell></TableCell>
        <TableCell center></TableCell>
        <TableCell center></TableCell>
      </TableRow>

      {roomRate.isPercentMarkup && (
        <TableRow>
          <TableCell>Antkainis, %</TableCell>
          <TableCell center>{roomRate.markupPercentAdult}%</TableCell>
          <TableCell center>{roomRate.markupPercentChild}%</TableCell>
        </TableRow>
      )}

      <TableRow>
        <TableCell>Antkainis, €</TableCell>
        <TableCell center>€{roomRate.markupAmountAdult}</TableCell>
        <TableCell center>€{roomRate.markupAmountChild}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell sx={{ fontWeight: 'bold' }}>Viso kaina</TableCell>

        <TableCell center>€{roomRate.tripPriceAdult}</TableCell>
        <TableCell center>€{roomRate.tripPriceChild}</TableCell>
      </TableRow>
    </>
  );
};

export default RoomRatesTableRateEditorPriceBreakdown;
